import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SetupError", "Cell has repeated step id.", config.defaultMessage)